<mat-accordion multi togglePosition="before" class="asset-area w-full">
  <div class="related-assets-group mb-1">
    <mat-expansion-panel [expanded]="true" class="!mb-2">
      <mat-expansion-panel-header collapsedHeight="2.5rem" expandedHeight="2.5rem">
        <mat-panel-title class="text-2xl"
          ><span class="title-prefix" i18n>Buyout rights:</span>&nbsp;<span class="title-suffix">{{ formValue.usageRightsGeneralInformation.buyoutRightsTitle.name }}</span></mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="w-full formField-viewer py-4">
        <div class="section mx-2" *ngIf="buyoutRightsConfigs[formValue.usageRightsGeneralInformation.buyoutRightsTitle._id]">
          <h3 class="text-xl font-semibold mb-4" i18n *ngIf="formValue.usageRightsGeneralInformation.buyoutRightsTitle._id !== notesColumnName">General info</h3>
          <div class="general-info-details">
            <ng-container *ngFor="let buyoutRightsConfig of buyoutRightsConfigs[formValue.usageRightsGeneralInformation.buyoutRightsTitle._id]">
              <header class="general-info-details-header" *ngIf="buyoutRightsConfig.fieldType === 'label'">
                <h4 class="general-info-details-label text-base !font-bold">{{ buyoutRightsConfig.fieldLabel }}</h4>
              </header>
              <ng-template
                [ngIf]="
                  formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName || ''] &&
                  (buyoutRightsConfig.fieldType !== 'multiSelectChip' ||
                    (buyoutRightsConfig.fieldType === 'multiSelectChip' && formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName][0]))
                "
              >
                <div class="general-info-details-entry">
                  <h4 class="general-info-details-label">
                    {{ buyoutRightsConfig.fieldLabel }}
                  </h4>
                  <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType === 'date'">
                    {{ formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName || ''].toString() | spDateFormat: { isSafe: true, plainDate: true } }}
                  </div>
                  <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType === 'dropdown'">
                    {{ formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName]._id | optionsLabel: buyoutRightsConfig.options }}
                  </div>
                  <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType === 'multiSelectChip'">
                    <div class="flex row items-start gap-1" *ngIf="formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName]">
                      <ng-template ngFor let-multiSelectField let-i="index" [ngForOf]="formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName]">
                        {{ (i > 0 ? ', ' : '') + multiSelectField.name }}
                      </ng-template>
                    </div>
                  </div>
                  <div
                    class="general-info-details-value fill-available-space"
                    *ngIf="buyoutRightsConfig.fieldType === 'textarea'"
                    [innerHTML]="formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName || '']"
                  ></div>
                  <div
                    class="general-info-details-value"
                    *ngIf="
                      buyoutRightsConfig.fieldType !== 'multiSelectChip' &&
                      buyoutRightsConfig.fieldType !== 'textarea' &&
                      buyoutRightsConfig.fieldType !== 'date' &&
                      buyoutRightsConfig.fieldType !== 'dropdown'
                    "
                  >
                    {{ formValue.usageRightsGeneralInformation[buyoutRightsConfig.formFieldName || ''] | optionsLabel: buyoutRightsConfig.options | spDateFormat: { isSafe: true, plainDate: true } }}
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <div class="text-xl font-semibold my-4" i18n *ngIf="columns.length > 0">Buyout rights</div>
          <div class="table border-separate border-spacing-2 w-full" *ngIf="columns.length > 0">
            <div class="table-header-group font-bold">
              <ng-container *ngFor="let col of columns">
                <div class="table-cell px-3">{{ col.header }}</div>
              </ng-container>
            </div>
            <div class="table-row-group">
              <ng-container *ngFor="let buyoutRight of formValue.buyoutRights.buyoutRightsFormArray; let i = index">
                <div class="table-row shadow-[0_3px_10px_rgb(0,0,0,0.2)] rounded-lg">
                  <ng-container *ngFor="let col of columns">
                    <div class="table-cell p-3">{{ buyoutRight[col['columnDef']] ?? dateMultiEditText[i] | keyValueUtil: 'value' : undefined : col['columnDef'] }}</div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</mat-accordion>
